<template>
  <v-app>
    <router-view />
    
    <Footer v-if="$route.name !== 'login'" />
  </v-app>
</template>

<script>
import "./assets/style/fonts.css";
import "./assets/style/style.css";
import Footer from './common/footer'
import axios from 'axios'
import store from './store'

export default {
  name: 'App',
  components: { Footer },
  beforeMount() {
    this.checkAuth();
  },
  methods: {
    checkAuth() {
      const token = localStorage.getItem("token");
      if (token) {
        axios.get("/user/admin/get", { headers: { token } })
          .then((res) => {
            if (res.data.status) {
              store.commit("userData", res.data.data);
              store.commit("userType", res.data.data.role);
            }
          }).catch(err => console.error(err));
      }
    }
  }
};
</script>